import { gql } from '@/__generated__/gql';

export const DEAL_ASSISTANT_AI_PROMPT_SETTING_SUMMARY_CONTEXT_GLOBAL_DEFAULT_QUERY = gql(`
  query dealAssistantAIPromptSettingSummaryContextGlobalDefault {
    dealAssistantAIPromptSettingSummaryContextGlobalDefault {
      defaultContextPrompt
      defaultSummaryPrompt
    }
  }
`);

export const CREATE_DEAL_ASSISTANT_AI_PROMPT_GROUP_MUTATION = gql(`
  mutation createDealAssistantAIPromptGroup($data: DealAssistantPromptGroupCreateDto!) {
    createDealAssistantAIPromptGroup(data: $data) {
      id
      prompts
      summaryPrompt
      contextPrompt
      outputStructure
      useCustomContextPrompt
      useCustomSummaryPrompt
    }
  }
`);

export const UPDATE_DEAL_ASSISTANT_AI_PROMPT_GROUP_MUTATION = gql(`
  mutation updateDealAssistantAIPromptGroup($data: DealAssistantPromptGroupUpdateDto!) {
    updateDealAssistantAIPromptGroup(data: $data) {
      id
      prompts
      summaryPrompt
      contextPrompt
      outputStructure
      useCustomContextPrompt
      useCustomSummaryPrompt
    }
  }
`);

export const DELETE_DEAL_ASSISTANT_AI_PROMPT_GROUP_MUTATION = gql(`
  mutation deleteDealAssistantAIPromptGroup($id: String!) {
    deleteDealAssistantAIPromptGroup(id: $id)
  }
`);
